const React = require('react')
const PropTypes = require('prop-types')

function TestimonialItem({ item }) {
    // don't render if there's no quote
    if (! item.quote) return null

    const quote = item.quote.replace(/^["'“”]/, '')

    return (
        <div className="testimonial glyph-quote">
            <div className="quote">{quote}</div>
            <div className="attribution">{item.attribution}</div>
        </div>
    )
}

TestimonialItem.propTypes = {
    item: PropTypes.object.isRequired,
}

module.exports = TestimonialItem
